import React from "react";
import { ArrowRight, DoorOpen, Fence, MapPin, Milestone, Phone, Warehouse, BoxIcon } from "lucide-react";
import { business, heroSpecialties, images, trustPoints } from "../data/site";
const specialtyIcons: Record<string, BoxIcon> = {
  fence: Fence,
  entry: Milestone,
  gate: DoorOpen,
  carport: Warehouse
};
export function Hero() {
  return <section id="top" className="relative isolate overflow-hidden bg-steel-950" data-id="element-125" data-mp="4njpeactjvaz">
      <img src={images.weldTee} alt="Close-up of a hand-welded pipe joint on a Triple D fence brace" className="absolute inset-0 h-full w-full object-cover object-center" style={{
      filter: 'grayscale(0.95) contrast(1.05) brightness(0.85)'
    }} data-id="element-126" data-mp="12862k3i3uktp" />
      <div className="absolute inset-0 bg-gradient-to-r from-black via-black/85 to-black/45" aria-hidden="true" data-id="element-127" data-mp="ncglmjrs0xvu" />

      <div className="relative mx-auto max-w-[1400px] px-5 pb-16 pt-36 sm:pt-44 lg:px-10 lg:pb-24 lg:pt-52" data-id="element-128" data-mp="3d21ty23jwspu">
        <div className="max-w-3xl" data-id="element-129" data-mp="3825wklpczzj9">
          <div className="flex items-center gap-3" data-id="element-130" data-mp="3814c5qmge0ov">
            <span className="h-[2px] w-10 bg-brand" aria-hidden="true" data-id="element-131" data-mp="3j896tarbk7oh" />
            <span className="font-mono text-[11px] uppercase tracking-[0.28em] text-brand-light" data-id="element-132" data-mp="3o7lqxnqt30nd">
              {business.base} · Fence · Gate · Carport Builders
            </span>
          </div>

          <h1 className="mt-6 font-display text-[13vw] font-bold uppercase leading-[0.86] tracking-[-0.01em] text-white sm:text-6xl lg:text-[104px]" data-id="element-133" data-mp="3e9fsjg47kcn9">
            Built Strong.
            <span className="block text-brand-light" data-id="element-134" data-mp="30fy87t3p6vw6">Welded Right.</span>
          </h1>

          <p className="mt-7 max-w-xl text-base leading-relaxed text-steel-200 sm:text-lg" data-id="element-135" data-mp="35aawqhk16xes">
            Custom fencing, ranch entryways, driveway gates, and carports built and installed across
            {' '}
            {business.base} — plus mobile welding and repair for everything else made of steel.
          </p>

          <div className="mt-10 flex flex-col gap-3 sm:flex-row sm:items-center" data-id="element-136" data-mp="2hlj8u2dh517t">
            <a href={business.phoneHref} className="group inline-flex items-center justify-center gap-3 bg-brand px-8 py-5 font-display text-sm font-semibold uppercase tracking-[0.16em] text-white transition-colors hover:bg-white hover:text-black" data-id="element-137" data-mp="2ljz0ijki2xrk">
              <Phone className="h-4 w-4" aria-hidden="true" data-id="element-138" data-mp="ibp02q9eowx0" />
              Call {business.phone}
            </a>
            <a href="#contact" className="group inline-flex items-center justify-center gap-3 border border-white/25 px-8 py-5 font-display text-sm font-semibold uppercase tracking-[0.16em] text-white transition-colors hover:border-brand hover:text-brand-light" data-id="element-139" data-mp="de6oes4083lb">
              Request a Quote
              <ArrowRight className="h-4 w-4 transition-transform group-hover:translate-x-1" aria-hidden="true" data-id="element-140" data-mp="111yb8pn67z0u" />
            </a>
          </div>

          <ul className="mt-12 grid grid-cols-2 gap-px border border-white/10 bg-white/10 sm:grid-cols-4" data-id="element-141" data-mp="x37cke3249bm">
            {heroSpecialties.map(item => {
            const Icon = specialtyIcons[item.icon];
            return <li key={item.title} className="bg-black/70 px-4 py-5 backdrop-blur-sm" data-id="element-142" data-mp="3htq0hyq6ywpm">
                  <Icon className="h-6 w-6 text-brand-light" aria-hidden="true" data-id="element-143" data-mp="1x7853o1s1ru4" />
                  <div className="mt-3 font-display text-base font-semibold uppercase tracking-[0.1em] text-white" data-id="element-144" data-mp="21bfs9gsl6zq8">
                    {item.title}
                  </div>
                </li>;
          })}
          </ul>

          <ul className="mt-8 flex flex-wrap gap-x-6 gap-y-2" data-id="element-145" data-mp="2b2snmidlg810">
            {trustPoints.map(point => <li key={point} className="flex items-center gap-2 font-mono text-[11px] uppercase tracking-[0.16em] text-steel-300" data-id="element-146" data-mp="2fziz0segefg3">
                <span className="h-1.5 w-1.5 bg-brand" aria-hidden="true" data-id="element-147" data-mp="2p0qockyzs5y1" />
                {point}
              </li>)}
          </ul>
        </div>

        <div className="mt-14 hidden items-center gap-3 font-mono text-xs uppercase tracking-[0.2em] text-steel-300 lg:flex" data-id="element-148" data-mp="2tyaae71xln0j">
          <MapPin className="h-4 w-4 text-brand-light" aria-hidden="true" data-id="element-149" data-mp="uokf3rpnrz8d" />
          Serving a 60-mile radius out of {business.base}
        </div>
      </div>
    </section>;
}